import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import CollapsableCard from 'components/CollapsableCard'
import { doFetchCustomProfile } from 'ducks/inAppCards/customProfile'
import {
  selectAccountPrefersUnsafeCustomProfile,
  selectAccountPreferenceCustomProfileAppInstalled,
} from 'selectors/app'
import {
  selectSidebarCardData,
  selectIsSidebarCardFailed,
  selectIsSidebarCardLoading,
} from 'selectors/sidebar_cards'
import { selectCurrentCustomerId } from 'selectors/tickets'

import SortableVisibleControlsWithTitle from '../../../SortableVisibleControlsWithTitle'

import Content from './Content'

export default function CustomProfile({ doHideCard, width }) {
  const dispatch = useDispatch()
  const customerId = useSelector(selectCurrentCustomerId)
  const cardId = `custom-profile-${customerId}`
  const isFailed = useSelector(selectIsSidebarCardFailed)(cardId)
  const isLoading = useSelector(selectIsSidebarCardLoading)(cardId)
  const isSafe = !useSelector(selectAccountPrefersUnsafeCustomProfile)
  const showCustomProfile = useSelector(
    selectAccountPreferenceCustomProfileAppInstalled
  )
  const { text } =
    useSelector(state => selectSidebarCardData(state)(cardId)) || {}
  const load = useCallback(
    () => {
      dispatch(doFetchCustomProfile(customerId))
    },
    [dispatch, customerId]
  )
  useEffect(load, [load])

  if (!showCustomProfile) return null
  return (
    <CollapsableCard
      persistenceKey={'customWidget.custom_profile'}
      title={
        <SortableVisibleControlsWithTitle
          onHide={doHideCard}
          title="Custom profile"
        />
      }
    >
      <Content
        isFailed={isFailed}
        isLoaded={isLoading}
        isSafe={isSafe}
        onRetry={load}
        text={text}
        width={width}
      />
    </CollapsableCard>
  )
}
